var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "business-team-container content-max-width" },
    [
      _c(
        "div",
        { staticClass: "filter flex" },
        _vm._l(_vm.filter, function(item, index) {
          return _c("div", { key: index, staticClass: "custom-radio" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.payload.filter,
                  expression: "payload.filter"
                }
              ],
              attrs: { type: "radio", name: "filter" },
              domProps: {
                value: item.value,
                checked: _vm._q(_vm.payload.filter, item.value)
              },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.payload, "filter", item.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(item.label))])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "team flex" },
        _vm._l(_vm.team, function(person, index) {
          return _c("article", { key: index }, [
            _c(
              "div",
              {
                staticClass: "wrap js-inline-popup",
                on: {
                  click: function($event) {
                    return _vm.toggleInfo(index)
                  }
                }
              },
              [
                _c("div", { staticClass: "image" }, [
                  _c("img", {
                    attrs: { src: person.preview_image, alt: person.name }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("h3", [_vm._v(_vm._s(person.name))]),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(person.title))]),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "mailto:" + person.email } }, [
                    _vm._v(_vm._s(person.email))
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Read Bio")])
                ])
              ]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.payload.nextUrl
        ? _c(
            "div",
            {
              staticClass: "load-more content-max-width",
              attrs: { disabled: _vm.isDisabled },
              on: {
                click: function($event) {
                  return _vm.loadTeam(true)
                }
              }
            },
            [
              _c(
                "a",
                { staticClass: "load-more-btn button large blue-border" },
                [_vm._v("Load More")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "team-popup", class: { open: _vm.isModalOpen } },
        [
          _c("span", { staticClass: "bg", on: { click: _vm.closeModal } }),
          _vm._v(" "),
          _c("div", { staticClass: "content-container" }, [
            _c("button", {
              staticClass: "close-button",
              on: { click: _vm.closeModal }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-between" }, [
              _c("div", { staticClass: "image" }, [
                _c("img", {
                  attrs: {
                    src: _vm.activePerson.preview_image,
                    alt: _vm.activePerson.name
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "info" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.activePerson.name))]),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.activePerson.title))]),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { href: "mailto:" + _vm.activePerson.email } },
                    [_vm._v(_vm._s(_vm.activePerson.email))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wysiwyg" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.activePerson.description)
                    }
                  })
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7b907fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7b907fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/business-team/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c7b907fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/business-team/Index.vue
// module chunks = 0